import {
  IMenuRepository,
  MenuItemEntity,
  ResponseValueObject,
} from '@gishub/domain';

export class MenuRepository implements IMenuRepository {
  async getItems(): Promise<ResponseValueObject<MenuItemEntity[]>> {
    return new ResponseValueObject(true, [
      { id: 'layers', code: 'midagri00507', componentName: 'layer', isPublic: true, group: 'primary', label: 'Capas', icon: 'layers', title: 'Capas del Mapa' },
      { id: 'measure', code: 'midagri00507', componentName: 'measure', isPublic: true, group: 'primary', label: 'Medir', icon: 'ruler', title: 'Medición' },
      { id: 'graphic', code: 'midagri00507', componentName: 'graphic', isPublic: true, group: 'primary', label: 'Gráfico', icon: 'pen', title: 'Dibujar / Anotar' },
      //{ id: 'analysis', code: 'midagri00802', componentName: 'analysis', isPublic: false, group: 'tools', label: 'Análisis', icon: 'bar-chart', title: 'Análisis' },
      { id: 'print', code: 'midagri00507', componentName: 'print', isPublic: true, group: 'tools', label: 'Impresión', icon: 'printer', title: 'Impresión' },
      { id: 'ogc', code: 'midagri00505', componentName: 'ogc', isPublic: true, group: 'tools', label: 'Cargar', icon: 'upload', title: 'Cargar información' },
      //{ id: 'bookmarks', code: 'midagri01101', componentName: 'bookmark', isPublic: false, group: 'tools', label: 'Marcadores', icon: 'bookmark', title: 'Marcadores' },
      { id: 'tour-route', code: 'midagri00507', componentName: 'tour-route', isPublic: true, group: 'primary', label: 'Recorrido', icon: 'route', title: 'Recorrido' },
      { id: 'flight', code: 'midagri00507', componentName: 'flight', isPublic: true, group: 'primary', label: 'Vuelo', icon: 'plane', title: 'Trazar ruta de vuelo' },
    ]);
  }
}
